query getSavedContents($input: GetSavedContentsInput!) {
  savedContents: getSavedContents(input: $input) {
    total
    numberOfPosts
  }
}
